import React, { useEffect, useState } from 'react'
import CountUp from 'react-countup';
import axios from 'axios';
import Atropos from 'atropos/react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { apiRequest } from '../../apiServices/allApi';
import Swal from 'sweetalert2'

// import "../../";

export default function AgentData() {

  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const location = useLocation();
  const path = location.pathname.split("/")[3];
  const [wallet, setWallet] = useState();



  const meedata = localStorage.getItem("uData");
  const userData = JSON.parse(meedata);


  const [Agent, setAgent] = useState()
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const admin = async (s, e) => {
    const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    try {
      const res = await apiRequest(`admin/agent/allData/${path}?startingfrom=` + s + "&endto=" + e, "GET", null, headers)
      if (res.data) {
        setAgent(res.data)
      }
    } catch (e) {
      // setLoading(false)

    }
    finally {
    }
  }

  const WalletHis = async () => {
    // setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`history/Security_Deposit/${path}`, "GET", null, headers)
      if (res.data) {

        setWallet(res.data);
        // setNumberOfPages(res.data.totalPages);
        // $("table").dataTable();
        // console.log(path)
      }
    } catch (e) {
      console.log(e);
      // setLoading(false);
    }
    finally {
    }
  };


  function filterData() {
    admin(new Date(startDate), new Date(endDate));
  }

  function daterange(s, e) {
    if (s > e) {
      alert("Starting date is greater than ending date");
    } else {
      setStartDate(s);
      setEndDate(e);
    }
    console.log(s, e)
    // Change start date format
    var startDate = new Date(s);
    var startDay = startDate.getDate();
    var startMonth = startDate.getMonth() + 1; // Months are zero-based
    var startYear = startDate.getFullYear();
    var startHours = startDate.getHours();
    var startMinutes = startDate.getMinutes();
    var startSeconds = startDate.getSeconds();

    // Change end date format
    var endDate = new Date(e);
    var endDay = endDate.getDate();
    var endMonth = endDate.getMonth() + 1; // Months are zero-based
    var endYear = endDate.getFullYear();
    var endHours = endDate.getHours();
    var endMinutes = endDate.getMinutes();
    var endSeconds = endDate.getSeconds();


  }

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleString("default", {
      month: "long",
      day: "numeric",
      hour: "numeric",
      hour24: true,
      minute: "numeric",
    });
    return newDate;
  };

  const imageopen = (image) => {
    Swal.fire({
      title: "Pay Qr Code",
      text: "",

      imageUrl: baseUrl + `/${image}`,
      imageWidth: 400,
      imageHeight: 300,
      imageAlt: "Custom image"
    })
  }
  useEffect(() => {
    admin(new Date(new Date().setHours(0, 0, 0, 0)), new Date());
    WalletHis()

  }, [])

  return (
    <>
      {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
      <div className="row mt-4">

        <div className='col-xl-12 col-sm-12'>
          <div className="form-group mx-sm-3 mb-2">
            <label htmlFor="startDate" className="sr-only">
              Start Date
            </label>
            <input type="datetime-local" id="" name="" className="form-control" value={startDate} onChange={(e) => daterange(e.target.value, endDate)}></input>

          </div>
          <h5>To</h5>
          <div className="form-group mx-sm-3 mb-2">
            <label htmlFor="endDate" className="sr-only">
              End Date
            </label>
            <input type="datetime-local" id="" name="" className="form-control" value={endDate} onChange={(e) => daterange(startDate, e.target.value)}></input>

          </div>
          <button className="btn btn-success mb-4" onClick={filterData}>Submit</button>
        </div>

        <Atropos rotateXMax={15} shadowScale={0.7} shadowOffset={50} rotateYMax={15} stretchX={50} className="col-xl-3 col-sm-6 grid-margin mb-0 stretch-card my-atropos" >
          <div className="card">
            <div className="card-body text-light border-primary"  >
              <h4 className="font-weight-normal text-primary">TODAY DEPOSIT</h4>
              <div className="d-flex align-items-center align-self-start">
                <h3 className=" display-3 text-primary mb-0"><CountUp start={0} delay={0.1} duration={0.2} end={Agent?.todayDeposit} /></h3>
              </div>
            </div>
          </div>
        </Atropos>
        <Atropos rotateXMax={15} shadowScale={0.7} shadowOffset={50} rotateYMax={15} stretchX={50} className="col-xl-3 col-sm-6 grid-margin mb-0 stretch-card my-atropos" >
          <div className="card ">
            <div className="card-body text-light border-primary"  >
              <h4 className="font-weight-normal text-primary">TOTAL DEPOSIT</h4>
              <div className="d-flex align-items-center align-self-start">
                <h3 className=" display-3 text-primary mb-0"><CountUp start={0} delay={0.1} duration={0.2} end={Agent?.totalDeposit} /></h3>
              </div>
            </div>
          </div>
        </Atropos>
        <Atropos rotateXMax={15} shadowScale={0.7} shadowOffset={50} rotateYMax={15} stretchX={50} className="col-xl-3 col-sm-6 grid-margin mb-0 stretch-card my-atropos" >
          <div className="card">
            <div className="card-body text-light border-primary"  >
              <h4 className="font-weight-normal text-primary">TODAY KVM-WITHDRAW</h4>
              <div className="d-flex align-items-center align-self-start">
                <h3 className=" display-3 text-primary mb-0"><CountUp start={0} delay={0.1} duration={0.2} end={Agent?.todayKvmWithdraw} /></h3>
              </div>
            </div>
          </div>
        </Atropos>
        <Atropos rotateXMax={15} shadowScale={0.7} shadowOffset={50} rotateYMax={15} stretchX={50} className="col-xl-3 col-sm-6 grid-margin mb-0 stretch-card my-atropos" >
          <div className="card">
            <div className="card-body text-light border-primary"  >
              <h4 className="font-weight-normal text-primary">TODAY M-WITHDRAW</h4>
              <div className="d-flex align-items-center align-self-start">
                <h3 className=" display-3 text-primary mb-0"><CountUp start={0} delay={0.1} duration={0.2} end={Agent?.todayManualWithdraw} /></h3>
              </div>
            </div>
          </div>
        </Atropos>
        <Atropos rotateXMax={15} shadowScale={0.7} shadowOffset={50} rotateYMax={15} stretchX={50} className="col-xl-3 col-sm-6 grid-margin mb-0 stretch-card my-atropos" >
          <div className="card">
            <div className="card-body text-light border-primary"  >
              <h4 className="font-weight-normal text-primary">TOTAL KVM-WITHDRAW</h4>
              <div className="d-flex align-items-center align-self-start">
                <h3 className=" display-3 text-primary mb-0"><CountUp start={0} delay={0.1} duration={0.2} end={Agent?.totalKvmWithdraw} /></h3>
              </div>
            </div>
          </div>
        </Atropos>
        <Atropos rotateXMax={15} shadowScale={0.7} shadowOffset={50} rotateYMax={15} stretchX={50} className="col-xl-3 col-sm-6 grid-margin mb-0 stretch-card my-atropos" >
          <div className="card">
            <div className="card-body text-light border-primary"  >
              <h4 className="font-weight-normal text-primary">TOTAL M-WITHDRAW</h4>
              <div className="d-flex align-items-center align-self-start">
                <h3 className=" display-3 text-primary mb-0"><CountUp start={0} delay={0.1} duration={0.2} end={Agent?.totalManualWithdraw} /></h3>
              </div>
            </div>
          </div>
        </Atropos>
        <Atropos rotateXMax={15} shadowScale={0.7} shadowOffset={50} rotateYMax={15} stretchX={50} className="col-xl-3 col-sm-6 grid-margin mb-0 stretch-card my-atropos" >
          <div className="card">
            <div className="card-body text-light border-primary"  >
              <h4 className="font-weight-normal text-primary">TODAY BONUS</h4>
              <div className="d-flex align-items-center align-self-start">
                <h3 className=" display-3 text-primary mb-0"><CountUp start={0} delay={0.1} duration={0.2} end={Agent?.todayBouns} /></h3>
              </div>
            </div>
          </div>
        </Atropos>
        <Atropos rotateXMax={15} shadowScale={0.7} shadowOffset={50} rotateYMax={15} stretchX={50} className="col-xl-3 col-sm-6 grid-margin mb-0 stretch-card my-atropos" >
          <div className="card">
            <div className="card-body text-light border-primary"  >
              <h4 className="font-weight-normal text-primary">TOTAL BONUS</h4>
              <div className="d-flex align-items-center align-self-start">
                <h3 className=" display-3 text-primary mb-0"><CountUp start={0} delay={0.1} duration={0.2} end={Agent?.totalBouns} /></h3>
              </div>
            </div>
          </div>
        </Atropos>
        <Atropos rotateXMax={15} shadowScale={0.7} shadowOffset={50} rotateYMax={15} stretchX={50} className="col-xl-3 col-sm-6 grid-margin mb-0 stretch-card my-atropos" >
          <div className="card">
            <div className="card-body text-light border-primary"  >
              <h4 className="font-weight-normal text-primary">TODAY PENALTY</h4>
              <div className="d-flex align-items-center align-self-start">
                <h3 className=" display-3 text-primary mb-0"><CountUp start={0} delay={0.1} duration={0.2} end={Agent?.todayPenalty} /></h3>
              </div>
            </div>
          </div>
        </Atropos>
        <Atropos rotateXMax={15} shadowScale={0.7} shadowOffset={50} rotateYMax={15} stretchX={50} className="col-xl-3 col-sm-6 grid-margin mb-0 stretch-card my-atropos" >
          <div className="card">
            <div className="card-body text-light border-primary"  >
              <h4 className="font-weight-normal text-primary">TOTAL PENALTY</h4>
              <div className="d-flex align-items-center align-self-start">
                <h3 className=" display-3 text-primary mb-0"><CountUp start={0} delay={0.1} duration={0.2} end={Agent?.totalPenalty} /></h3>
              </div>
            </div>
          </div>
        </Atropos>
      </div>
      <h4 className='mb-3'>Agent Wallet History</h4>
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th> ID</th>
              <th> Amount </th>
              <th>Closing Balance</th>
              <th>Reason</th>
              <th>Image</th>
              <th> Status</th>
              <th> Action By</th>
              <th> Date</th>
            </tr>
          </thead>
          <tbody>
            {wallet?.map((data, key) => {
              // console.log(data.Game_Amount)
              return (
                <tr
                  key={key}
                  style={{
                    color:
                      data.Req_type == "deposit"
                        ? "green"
                        : data.Req_type == "withdraw"
                          ? "		#ff7f50"
                          : "black",
                  }}
                >
                  <td>{key + 1}</td>
                  <td>{data._id}</td>
                  <td>{data.amount}</td>
                  <td>{data.closing_balance}</td>
                  <td>{data.txn_msg}</td>

                  <td>

                    <img src={baseUrl + `/${data.paymentImage}`}
                      onClick={() => imageopen(data.paymentImage)}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/error.png";
                      }}
                    />
                  </td>
                  <td
                    style={{
                      fontWeight: "bold",
                      color:
                        data.status == "SUCCESS"
                          ? "seagreen"
                          : data.status == "completed"
                            ? "royalblue"
                            : data.status == "cancelled"
                              ? "salmon"
                              : data.status == "FAILED"
                                ? "red"
                                : "red",
                    }}
                  >
                    {data.status}
                    {data.status == "PAID" ? (
                      <span>&#9989;</span>
                    ) : data.status == "FAILED" ? (
                      <span>&#10060;</span>
                    ) : (
                      ""
                    )}
                  </td>
                  <td>{data?.action_by?.Name}</td>

                  {/* <td>{data.date} </td> */}
                  <td>{dateFormat(data.updatedAt)} </td>

                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

    </>
  )
}
